import {TeamSlider} from "./TeamSlider";
import "../../Sections/Team/TeamSection.css";


export default function TeamSection() {
  return (
    <section className="team-section">
      <h2 className="team-title">Our team</h2>
      <div className="box-slider-team">
        <TeamSlider/>
      </div>
    </section>
  );
}

